
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/developer-career-report-2025",
      function () {
        return require("private-next-pages/developer-career-report-2025.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/developer-career-report-2025"])
      });
    }
  